import React from "react";

import { Link } from "../../../common/Link";
import { IProduct } from "../../../models/catalogue.interfaces";
import { getOptionValueDisplayName } from "../../../utils/catalogue";
import { listOptions } from "./utils";

import styles from "./common.module.scss";

export const BasketLineTitle = (props: {
    product: IProduct;
    additionalCSSClass?: string;
}): React.ReactNode => {
    let title = props.product.parent
        ? props.product.parent.title
        : props.product.title;
    if (props.product.parent) {
        const titleOptions = listOptions(props.product)
            .filter((option) => option.key !== "option_color")
            .map((option) =>
                getOptionValueDisplayName(option.name, option.value),
            )
            .filter((name) => !!name)
            // TODO(i18n): Don't hardcode ", " separator - different languages use different list separators. Consider using Intl.ListFormat or a translatable format string.
            .join(", ");
        if (titleOptions) {
            // TODO(i18n): Don't concatenate strings with hardcoded ", " - word order and punctuation vary by language. Use a translatable format like t`${title}, ${titleOptions}` to keep the complete phrase together.
            title = title + ", " + titleOptions;
        }
    }
    const productLink = props.product.parent
        ? props.product.parent.link
        : props.product.link;

    return (
        <h2 className={`${styles.productTitle} ${props.additionalCSSClass}`}>
            {productLink ? (
                <Link href={productLink} target="_top">
                    {title}
                </Link>
            ) : (
                <>{title}</>
            )}
        </h2>
    );
};
